export const selectUploadFileModuleData = (state) => {
  return state.uploadFileModule.data;
};

export const selectUploadFileModuleFiles = (state) => {
  return state.uploadFileModule.files;
};

export const selectSelectedModules = (state) => {
  return state.uploadFileModule.selected_modules;
};

export const selectSelectedModuleID = (state) => {
  return state.uploadFileModule.selected_module_id;
};

export const selectUserData = (state) => {
  return state.userData.data;
};
